export enum SecureStorageErrorCode {
  InvalidEncryptionKey = 'INVALID_ENCRYPTION_KEY',
  WrongPassword = 'PASSWORD_IS_WRONG',
  StorageIsUnlocked = '"STORAGE_IS_UNLOCKED"',
  StorageIsLocked = 'STORAGE_IS_LOCKED',
  StorageAlreadyInitialized = 'STORAGE_IS_ALREADY_INITIALIZED',
  DeriveKeyError = 'UNABLE_TO_DERIVE_KEY_FROM_PASSWORD',
  DecryptionFailed = 'DECRYPTION_FAILED',
  SignPermitError = 'UNABLE_TO_SIGN_PERMIT_DATA',
  InternalError = 'INTERNAL_ERROR',
  StoreError = 'STORE_ERROR',
  StorageError = 'STORAGE_ERROR',
  AlreadyExistsAddress = 'Already exists address',
  WrongNetwork = 'WRONG_NETWORK',
  StorageNotFound = 'STORAGE_NOT_FOUND',
  StorageDesynced = 'STORAGE_DESYNCED',
  StorageNotFoundOrInitialized = '"Storage is not initialized (not found)"',
  InvalidDelugeId = 'INVALID_DELUGUE_ID',
}
